// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"_9e1425b4d3--tooltip--V83hj","arrow_tooltip":"_9e1425b4d3--arrow_tooltip--Iqx7l","arrow":"_9e1425b4d3--arrow--qKq6Q"};